import { makeObservable } from "mobx";
import searchService from "../service/SearchService";
import { SearchService } from "../service/SearchService";
import { SearchEmployeesResponse } from "../service/SearchEmployeesResponse";

export interface SearchStore {
    searchEmployees: (filterText: string) => Promise<SearchEmployeesResponse>;
}

export class DefaultSearchStore implements SearchStore {
    constructor(private service: SearchService) {
        makeObservable(this, {});
    }

    public async searchEmployees(filterText: string): Promise<SearchEmployeesResponse> {
        var apiResult = (await this.service.searchEmployees(filterText)).data;
        var result = {
            hasMore: apiResult?.hasMore ?? false,
            employees: (apiResult?.employees ?? []).map((v) => {
                return {
                    email: v.email,
                    displayName: v.displayName,
                };
            }),
        };
        return result;
    }
}

export default new DefaultSearchStore(searchService);
